export default "__VITE_ASSET__CXiCR0vD__"